import packageJson from "../../../package.json";

export function downloadFile(filename, code) {
    const element = document.createElement("a");
    const file = new Blob([code], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = filename;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
}

export function arrayMax(array) {
    return array.reduce(function (a, b) {
        return Math.max(a, b);
    });
}

export function arrayMin(array) {
    return array.reduce(function (a, b) {
        return Math.min(a, b);
    });
}

export function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
}

export function isLocal() {
    return process.env.NODE_ENV === "development";
}

export const isBrowser = typeof window !== `undefined`;

export function getPlatformNameFromUrl(url) {
    let hostname = url.split("https://")[1];
    let subdomain = hostname.split(".")[0];
    let platformName = subdomain.charAt(0).toUpperCase() + subdomain.slice(1);
    return platformName;
}

export function recolorBlocks(blocksToColor) {
    blocksToColor.forEach((blockType) => {
        let block = blockType.block;
        var oldInit = block.init;
        block.init = function () {
            oldInit.call(this);
            this.setColour(blockType.colour);
        };
    });
}

export function dispatchResizeEvent(delayTime) {
    window.setTimeout(
        () => {
            window.dispatchEvent(new Event("resize"));
        },
        delayTime ? delayTime : 200
    );
}

export function openInNewTab(url) {
    window.open(url, "_blank");
}

export const fetchHexFile = async (fileName) => {
    try {
        const response = await fetch(`${fileName}`);

        if (!response.ok) {
            throw new Error(
                `Failed to fetch ${fileName}: ${response.statusText}`
            );
        }

        const text = await response.text();
        return text;
    } catch (error) {
        console.error("Error fetching the hex file:", error);
        return null;
    }
};

export const isJSON = (obj) => {
    if (
        typeof obj === "object" &&
        obj !== null &&
        !(obj instanceof ArrayBuffer)
    ) {
        try {
            JSON.stringify(obj);
            return true;
        } catch (e) {
            return false;
        }
    }
    return false;
};

export const isIframe = () => {
    return window.location !== window.parent.location;
};

export const platformConfig = {
    Resolute: {
        basePath: isLocal()
            ? "http://localhost:8881"
            : "https://learn.resolute.education",
        subdomain: "resolute",
    },
    Staging: {
        basePath: "https://staging.resolute.education",
        subdomain: "dev",
    },
    Curro: {
        basePath: "https://curro.resolute.education",
        subdomain: "curro",
    },
    Advtech: {
        basePath: "https://advtech.resolute.education",
        subdomain: "advtech",
    },
    India: {
        basePath: "https://india.resolute.education",
        subdomain: "india",
    },
    Foundation: {
        basePath: "https://foundation.resolute.education",
        subdomain: "foundation",
    },
    Educel: {
        basePath: "https://core.resolute.education",
        subdomain: "core",
    },
    Silverfern: {
        basePath: "https://silverfern.resolute.education",
        subdomain: "silverfern",
    },
    UK: {
        basePath: "https://uk.resolute.education",
        subdomain: "uk",
    },
};

export const getOS = () => {
    let operatingSystem;
    if (navigator.userAgent.indexOf("Win") !== -1) operatingSystem = "Windows";
    if (navigator.userAgent.indexOf("Mac") !== -1) operatingSystem = "MacOS";
    if (navigator.userAgent.indexOf("X11") !== -1) operatingSystem = "UNIX";
    if (navigator.userAgent.indexOf("Linux") !== -1) operatingSystem = "Linux";
    return operatingSystem;
};

export const getSimulatorUrl = () => {
    let url;
    if (packageJson.homepage == "staging-resly-ide") {
        url = new URL(process.env.REACT_APP_STAGING_SIMULATOR_URL);
    } else {
        url = new URL(process.env.REACT_APP_SIMULATOR_URL);
    }
    url.searchParams.set("t", Date.now());
    return url.toString();
};

export const secureCookieSuffix = () =>
    window.location.protocol === "https:" ? "; Secure" : "";

export const expireCookie = (name) => {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax${secureCookieSuffix()}`;
};
